export { default as Game } from './game';
export { default as Loading } from './loading';
export { default as Splash } from './splash';
// export { default as DebugSymbols } from './debug-symbols';